import React, { useState, useEffect } from "react";
import { newsService } from "../../../services/newsService";
import { educationService } from "../../../services/Education.service";
import { REACT_APP_API_BASE_URL } from "../../../apiurl";
import "./MediaLibraryModal.css";

const MediaLibraryModal = ({ isOpen, onClose, onSelect, folder = "newsimages" }) => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    if (isOpen) fetchImages();
  }, [isOpen, folder]);

  const fetchImages = async () => {
    setLoading(true);
    try {
      let response;
      if (folder === "educationimages") {
        response = await educationService.getEducationImages();
      } else {
        response = await newsService.getNewsImages();
      }
      if (response.status) setImages(response.images || []);
    } catch (error) {
      console.error("Error fetching images:", error);
    } finally {
      setLoading(false);
    }
  };

  const filteredImages = images.filter((img) =>
    img.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (!isOpen) return null;

  return (
    <div className="media-modal-overlay">
      <div className="media-modal-content">
        <div className="media-modal-header">
          <h3>Media Library</h3>
          <button className="media-close-btn" onClick={onClose}>&times;</button>
        </div>
        <div className="media-modal-body">
          <input
            className="media-search"
            type="text"
            placeholder="Search images..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {loading ? (
            <div className="loading">Loading images...</div>
          ) : images.length === 0 ? (
            <div className="no-images">No images found in the library.</div>
          ) : (
            <div className="image-grid">
              {filteredImages.map((img, index) => (
                <div key={index} className="image-item" onClick={() => { onSelect(img); onClose(); }}>
                  <img src={`${REACT_APP_API_BASE_URL}uploads/${folder}/${img}`} alt={img} />
                  <span className="image-name">{img}</span>
                </div>
              ))}
              {filteredImages.length === 0 && images.length > 0 && (
                <div className="no-images">No matching images found.</div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MediaLibraryModal;